/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import "./filtering.css";

import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../services/AxiosInstance";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter }) => {
  return (
    <div>
      Search :{" "}
      <input
        type="search"
        className="ml-2 input-search form-control"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        style={{ width: "20%" }}
      />
    </div>
  );
};

export const Empolye = () => {
  const user = useSelector((state) => state.auth.auth);
  const keys = ["first_name", "last_name", "email"];
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const onShow = () => setShow(true);
  const onHide = () => setShow(false);
  // const [editshow, setEditShow] = useState(false);
  // const onEditShow = () => setEditShow(true);
  // const onEditHide = () => setEditShow(false);
  const [loader, setLoader] = useState(false);
  const [fieldvalue, setFieldValue] = useState({
    company_id: user?.localId,
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });

  const COLUMNS = [
    ...keys.map((key) => ({
      Header: key.replace(/_/g, " "),
      Footer: key.replace(/_/g, " "),
      accessor: key,
      Filter: ColumnFilter,
    })),
    // {
    //   Header: "Action",
    //   Footer: "Action",
    //   Cell: ({ row }) => {
    //     const DeleteSubModule = (id) => {
    //       setLoader(true);
    //       try {
    //         axiosInstance
    //           .get(`admin/submodule/delete/${id}`)
    //           .then((response) => {
    //             if (response.data.status === true) {
    //               getSubModule();
    //               toast.success(response.data.message);
    //               setLoader(false);
    //             } else {
    //               toast.error("SomeThing went Wrong");
    //               setLoader(false);
    //             }
    //           })
    //           .catch((errors) => {
    //             toast.error("SomeThing went Wrong");
    //             setLoader(false);
    //           });
    //       } catch (error) {
    //         toast.error(error);
    //       }
    //     };
    //     return (
    //       <>
    //         <div className="d-flex gap-2">
    //           <button
    //             onClick={() => {
    //               getSubModuleID(row.original.id);
    //             }}
    //             title="Edit"
    //             className={`btn btn-outline-success btn-sm rounded`}
    //           >
    //             <i className="fa fa-pen" />
    //           </button>
    //           <button
    //             onClick={() => {
    //               DeleteSubModule(row.original.id);
    //             }}
    //             title="Edit"
    //             className={`btn btn-outline-danger btn-sm rounded`}
    //           >
    //             <i className="fa fa-trash" />
    //           </button>
    //         </div>
    //       </>
    //     );
    //   },
    // },
  ];

  const [columns] = useState(COLUMNS);

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter, pageIndex } = state;

  const getEmploye = () => {
    setLoader(true);

    axiosInstance
      .get("company/employee/view")
      .then(function (response) {
        console.log(response, "Getting Compaines");
        if (response?.data.status === true) {
          setData(response?.data.data);
          setLoader(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error, "song Error");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
  };
  // const getSubModuleID = (id) => {
  //   setLoader(true);
  //   axiosInstance
  //     .get(`admin/submodule/edit/${id}`)
  //     .then(function (response) {
  //       console.log(response);
  //       if (response?.data.status === true) {
  //         setFieldValue(response?.data?.data);
  //         setLoader(false);
  //         onEditShow();
  //       } else {
  //         setLoader(false);
  //       }
  //     })
  //     .catch(function (error) {
  //       setLoader(false);
  //       console.log(error, "song Error");
  //       window.scrollTo({
  //         top: 0,
  //         behavior: "smooth",
  //       });
  //     });
  // };
  const addEmploye = () => {
    setLoader(true);
    var formdata = new FormData();
    for (const key in fieldvalue) {
      if (Object.hasOwnProperty.call(fieldvalue, key)) {
        formdata.append(key, fieldvalue[key]);
      }
    }
    axiosInstance
      .post(`company/employee/store`, formdata)
      .then((response) => {
        if (response.data.status) {
          getEmploye();
          onHide();
          toast.success(response.data.message);
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };
  // const updateSubModule = (id) => {
  //   setLoader(true);
  //   var formdata = new FormData();
  //   for (const key in fieldvalue) {
  //     if (Object.hasOwnProperty.call(fieldvalue, key)) {
  //       formdata.append(key, fieldvalue[key]);
  //     }
  //   }
  //   axiosInstance
  //     .post(`admin/submodule/update/${id}`, formdata)
  //     .then((response) => {
  //       if (response.data.status) {
  //         getEmpolye();
  //         onEditHide();
  //         toast.success(response.data.message);
  //         setLoader(false);
  //       } else {
  //         setLoader(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoader(false);
  //     });
  // };

  useEffect(() => {
    getEmploye();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue({ ...fieldvalue, [name]: value });
  };

  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="card">
        <div>
          <div className="card-header">
            <h4 className="card-title float-left">Users</h4>
            <button className="btn btn-primary float-end" onClick={onShow}>
              Add User
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table
              {...getTableProps()}
              id="table-to-export" // Add the id attribute
              className="table display"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {/* {column.canFilter ? column.render("Filter") : null} */}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between">
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>
              {""}
            </span>
            <span className="table-index">
              Go to page :{" "}
              <input
                type="number"
                className="ml-2"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  gotoPage(pageNumber);
                }}
              />
            </span>
          </div>
          <div className="text-center">
            <div className="filter-pagination  mt-3">
              <button
                className=" previous-button"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>

              <button
                className="previous-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Previous
              </button>
              <button
                className="next-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next
              </button>
              <button
                className=" next-button"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Add Modal */}
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Header closeButton>Add User</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">First Name</h5>
                <input
                  type={"text"}
                  name={"first_name"}
                  className="form-control"
                  onChange={handleInputChange}
                />
              </div>
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">Last Name</h5>
                <input
                  type={"text"}
                  name={"last_name"}
                  className="form-control"
                  onChange={handleInputChange}
                />
              </div>
              <div className={`mb-3 col-md-12`}>
                <h5 className="text-capitalize">Email</h5>
                <input
                  type={"email"}
                  name={"email"}
                  className="form-control"
                  onChange={handleInputChange}
                />
              </div>
              <div className={`mb-3 col-md-12`}>
                <h5 className="text-capitalize">Password</h5>
                <input
                  name={"password"}
                  type={"password"}
                  className="form-control"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Close
          </Button>
          <Button variant="success" onClick={addEmploye}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Add Modal Close */}
      {/* Update Modal Start */}
      {/* <Modal show={editshow} onHide={onEditHide} size="md">
        <Modal.Header closeButton>SubModule Detail</Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">Module Name</h5>
                <select
                  type={"text"}
                  name={"module_id"}
                  className="form-control"
                  onChange={handleInputChange}
                  defaultValue={fieldvalue.module_id}
                >
                  <option selected hidden>
                    Select Module Name.......
                  </option>
                  {modules?.map((e) => (
                    <option value={e?.id}>{e?.module_name}</option>
                  ))}
                </select>
              </div>
              <div className={`mb-3 col-6`}>
                <h5 className="text-capitalize">SubModule Name</h5>
                <input
                  type={"text"}
                  name={"sub_module_name"}
                  className="form-control"
                  defaultValue={fieldvalue.sub_module_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className={`mb-3 col-12`}>
                <h5 className="text-capitalize">Description</h5>
                <textarea
                  name={"description"}
                  className="form-control"
                  defaultValue={fieldvalue.description}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onEditHide}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => updateSubModule(fieldvalue.id)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* Update Modal Close */}
    </>
  );
};
export default Empolye;
